export const hourlyUsageConstants = {
    GET_HOURLY_REQUEST: 'GET_HOURLY_REQUEST',
    GET_HOURLY_SUCCESS: 'GET_HOURLY_SUCCESS',
    GET_HOURLY_FAILURE: 'GET_HOURLY_FAILURE',
    GET_YESTERDAY_USAGE_REQUEST: 'GET_YESTERDAY_USAGE_REQUEST',
    GET_YESTERDAY_USAGE_SUCCESS: 'GET_YESTERDAY_USAGE_SUCCESS',
    GET_YESTERDAY_USAGE_FAILURE: 'GET_YESTERDAY_USAGE_FAILURE'
}